<!-- BuildingAccessCardView -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div v-if="!initialLoading" class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>

                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                </div>
            </div>

            <div v-if="!initialLoading" class="col">

                <StepBar :steps="['เอกสารที่ต้องเตรียม', 'ประสงค์ขอทำบัตร', 'อัปโหลดเอกสาร', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="0" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                </div>

                <!-- เงื่อนไขและสิ่งที่ต้องเตรียม -->
                <div class="font-family-bla my-3">
                    <div class="carousel-border p-4 text-dark">
                        <h4>
                            <b>เงื่อนไขการขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน</b>
                        </h4>
                        <ol class="fs-5">
                            <li>ระดับผู้จัดการภาคขึ้นไป, ผู้บริหารขั้นพิเศษ (พ.) <span
                                    class="text-decoration-underline">ไม่ต้องเสียค่าใช้จ่าย</span> <span
                                    class="text-danger">(กรณีทำบัตรหาย/ชำรุด จะต้องชำระค่าทำบัตรใหม่เอง)</span></li>
                            <li>สำหรับตัวแทน ที่ไม่ได้รับสิทธิทำบัตรประจำตัวตามข้อ 1. ต้องชำระเงินค่าทำบัตรจำนวน 270 บาท
                            </li>
                            <li>บัตรประจำตัวผ่านเข้าออกอาคารสำนักงานมีอายุการใช้งาน 2 ปีปฏิทิน
                                นับแต่วันที่ออกบัตรประจำตัว</li>
                        </ol>

                        <h4 class="mt-4">
                            <b>สิ่งที่ต้องเตรียม</b>
                        </h4>
                        <ol class="fs-5">
                            <li>รูปถ่ายต้องเป็นไฟล์รูปถ่ายสี หน้าตรง พื้นหลังสีขาว เป็นไฟล์ชนิด .jpg เท่านั้น ขนาด 200
                                KB ขึ้นไปไม่เกิน 2 MB</li>
                        </ol>

                        <p class="fs-5 mt-4">
                            <b class="text-decoration-underline">หมายเหตุ</b> :
                            บัตรนี้ใช้เพื่ออำนวยความสะดวกในการผ่านเข้า-ออกอาคารสำนักงานเท่านั้น
                            ไม่ให้ใช้บัตรนี้แสดงต่อลูกค้า/ผู้เอาประกันแทนใบอนุญาตเป็นตัวแทนประกันชีวิต
                        </p>
                        <div class="mt-4">
                            <div class="form-check">
                                <input class="form-check-input fs-5" type="checkbox" id="consent1" v-model="consent1">
                                <label class="form-check-label fs-5" for="consent1">
                                    {{ consentText1 }}
                                </label>
                            </div>
                            <div class="form-check mt-2">
                                <input class="form-check-input fs-5" type="checkbox" id="consent2" v-model="consent2">
                                <label class="form-check-label fs-5" for="consent2">
                                    {{ consentText2 }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- ปุ่มดำเนินการต่อ -->
                    <div class="text-end mt-4">
                        <button class="btn btn-bla w-25" @click="goNext" :disabled="!consent1 || !consent2">
                            ถัดไป </button>
                    </div>
                </div>

            </div>

        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js'; // ต้องใช้ bundle!

import StepBar from "@/components/agenteservice/StepBar.vue";

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: "BuildingAccessCard",
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            Loading: true,
            initialLoading: true,
            isVerified: false, // ยังไม่ผ่านการเช็ค
            steps: ['เอกสารที่ต้องเตรียม', 'ประสงค์ขอทำบัตร', 'อัปโหลดเอกสาร', 'ชำระเงิน', 'เสร็จสิ้น'],
            consent1: false,
            consent2: false,
            consentText1: '', // Placeholder for API data
            consentText2: ''  // Placeholder for API data
        };
    },
    async created() {
        await this.getAgLevelDTL();
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();
        this.checkBuildingAccessCardServiceJob();
        this.fetchConsentTexts(); // Fetch consent texts

    },
    methods: {
        async getAgLevelDTL() {
            try {
                let AuthorizeToken = localStorage.getItem("AuthorizeToken");
                const response = await http.get(`AgencyERequest/GetAgLevelDTL`, {
                    headers: { Authorization: `Bearer ${AuthorizeToken}` }
                });

                if (response.data && response.data.AG_STATUS === 'ส') {
                    await Swal.fire({
                        icon: 'warning',
                        html: '<label class="fs-4 fw-normal font-family">ท่านเป็นผู้จัดการขั้นสมบูรณ์ (ส) กรุณาใช้บัตรที่ฝ่ายบริหารทรัพยากรบุคคลออกให้</label>',
                        confirmButtonText: 'ตกลง',
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                    this.$router.replace('/AgenteService');
                } else {
                    this.initialLoading = false;
                }
            } catch (error) {
                console.error("Error fetching agent level detail:", error);
                this.initialLoading = false;
            }
        },
        async checkBuildingAccessCardServiceJob() {
            try {
                let AuthorizeToken = localStorage.getItem("AuthorizeToken");
                await http.get(`AgencyERequest/CheckBuildingAccessCardServiceJob`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + (error.response?.data?.ErrorMessage || 'เกิดข้อผิดพลาดในการตรวจสอบข้อมูล') + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            }
        },
        async fetchConsentTexts() {
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            // Call API to get consent texts
            this.consentText1 = 'ข้าพเจ้ารับทราบและยินยอมให้บริษัทเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าอันได้แก่ รูปถ่าย, ชื่อ-นามสกุล และรหัสตัวแทน แก่บริษัทรับจ้างจัดทำบัตรภายนอกได้';
            this.consentText2 = 'ข้าพเจ้ารับทราบและจะปฏิบัติตามระเบียบปฏิบัติ เรื่อง ระเบียบการใช้อาคารสำนักงานใหญ่ เพื่อรักษาความเรียบร้อยภายในอาคารสำนักงานใหญ่ และ/หรือสำนักงานสาขา ตามที่บริษัทกำหนดอย่างเคร่งครัด';

            const pick = (o, ...keys) => keys.find(k => o?.[k] != null) && o[keys.find(k => o?.[k] != null)];

            const processConsent = (data, code, fallbackText) => {
                const consent = data.find(c => c.ConsentCode === code);
                let text = consent ? pick(consent, 'ContentThai', 'contentThai') : null;
                text = text ?? fallbackText;

                if (typeof text === 'string' && !/[<>]/.test(text.trim())) {
                    return text;
                }
                return text;
            };

            try {
                const res = await fetch(process.env.VUE_APP_URL_API + `AgencyERequest/GetConsentBySiteCode?siteCode=${encodeURIComponent("TC_AgencyERequest")}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${AuthorizeToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                const data = await res.json();
                this.consentText1 = processConsent(data, 'AER01', this.consentText1);
                this.consentText2 = processConsent(data, 'AER02', this.consentText2);

            } catch (e) {
                // ถ้าโหลดไม่ได้ จะใช้ข้อความ fallback เดิม และโชว์แจ้งเตือนเล็กน้อย
                console.warn('GetConsentBySiteCode failed:', e);
                // ไม่เด้ง error ใหญ่ เพื่อให้ผู้ใช้ยังอ่าน/ยอมรับได้
            }

        },
        checkLicenseNearExpiry() {
            this.Loading = true;

            // Call Api : ตรวจสอบว่ามีสิทธิ์ต่ออายุหรือไม่
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get(`AgencyERequest/CanRequestLicenseRenewal`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                this.Loading = false;

                if (response.status === 200) {
                    if (!response.data.isCanRequest) {
                        Swal.fire({
                            icon: "error",
                            title: "คำเตือน",
                            html: `ท่านไม่สามารถดำเนินการต่อไปได้ เนื่องจากเกินกำหนดระยะเวลาในการยื่นคำร้องขอต่ออายุใบอนุญาตฯ ออนไลน์ 
                                    <br>กรุณาติดต่อส่วนสัญญาตัวแทน อีเมล: <a href="mailto:agentcontract@bangkoklife.com">agentcontract@bangkoklife.com</a>
                                    <br>โทรศัพท์ : 02-777-8560, 8567
                                    <br>(ในเวลาทำการ จันทร์-ศุกร์ เวลา 08:30-17:00 น.)`,
                            // confirmButtonText: "ปิด",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            width: "auto", // ปล่อยให้ auto ไปก่อน
                            customClass: {
                                popup: 'swal-wide',
                                confirmButton: 'btn-bla btn-pill'
                            }
                        }).then(() => {
                            // เปลี่ยนไปหน้าเลือกเมนู
                            this.$router.replace('/AgenteService');
                        });
                    } else {
                        if (response.data.renewal === 4 &&
                            response.data.overdueResulPayment === "Y" &&
                            Array.isArray(response.data.listOverdue) &&
                            response.data.listOverdue.length > 0) {
                            const overdueHtml = response.data.listOverdue
                                .map(item => `
                                    <div style="display: flex;">
                                        <span style="margin-right: 8px;">-</span>
                                        <span>${item}</span>
                                    </div>`)
                                .join('');

                            Swal.fire({
                                icon: "error",
                                title: "คำเตือน",
                                html: `
                                        <!-- ข้อความบน (ตรงกลาง + ย่อหน้า) -->
                                        <div style=" text-align: center;margin-bottom: 10px;">
                                            ท่านไม่สามารถดำเนินการต่อไปได้ เนื่องจากมีรายการค้างชำระ ดังนี้ 
                                            กรุณาดำเนินการที่ระบบ Bangkok Life Training
                                        </div>

                                        <!-- รายการด้านล่าง (ชิดซ้าย) -->
                                        <div style="text-align: left; font-size: 19px; line-height: 1.7;">
                                        ${overdueHtml}

                                        </div>
                                `,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                                width: "auto", // ปล่อยให้ auto ไปก่อน
                                customClass: {
                                    popup: 'swal-wide ul-swal',
                                    confirmButton: 'btn-bla btn-pill'
                                }
                            }).then(() => {
                                this.$router.replace('/AgenteService');
                            });

                        } else {
                            this.$store.state.AgentRenewLicense.CanRequestLicenseRenewal = response.data;

                            // :: call api CheckAgentRenewLicenseServiceJob ::
                            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
                            http.get(`AgencyERequest/CheckAgentRenewLicenseServiceJob`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                            }).catch((error) => {
                                Swal.fire({
                                    icon: 'error',
                                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                                });
                            });
                            // :: call api CheckAgentRenewLicenseServiceJob ::

                            this.isVerified = true;
                            // this.BindingData();  // เรียก BindingData หลัง isVerified = true
                        }

                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง</label>',
                    });
                }
            }).catch((error) => {
                this.Loading = false;
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
        async acceptConsent(consentCode) {
            const AuthorizeToken = localStorage.getItem("AuthorizeToken");
            const payload = { consentCode };
            // error ที่นี่ ให้ re-throw เพื่อให้ goNext จัดการ
            await http.post(`AgencyERequest/AcceptConsentAgent`, payload, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });
        },
        async goNext() {
            this.Loading = true;
            try {
                // บันทึก consent ทั้งสองพร้อมกัน
                await Promise.all([
                    this.acceptConsent('AER01'),
                    this.acceptConsent('AER02')
                ]);

                // เมื่อสำเร็จแล้วจึงไปหน้าถัดไป
                this.$router.replace('/CardRequestType');
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    html: `<label class="fs-4 fw-normal font-family">${error.response?.data?.ErrorMessage || 'เกิดข้อผิดพลาดในการบันทึกความยินยอม'}</label>`,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla btn-pill'
                    }
                });
            } finally {
                this.Loading = false;
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    },
};

</script>

<style scoped>
.custom-btn-width {
    width: 100% !important;
    min-width: 150px;
    max-width: 300px;
}

.carousel-border {
    border: 2px solid #A2B9E2;
    border-radius: 10px;
}

.carousel-inner {
    border: 1px solid #dee2e6;
    border-radius: 8px;
}

.font-family-bla {
    font-family: "DB Heavent";
}
</style>